<template>
  <el-dialog
    title="设置文本内容"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :before-close="handleCancel"
    custom-class="text-edit-dialog"
    append-to-body
  >
    <!-- 文本输入框 -->
    <div class="input-wrapper">
      <el-input
        v-model="formData.content"
        placeholder="例如：已知悉签字、家长签字等"
        :style="{ color: formData.fontColor }"
      />
    </div>

    <!-- 字体大小和颜色选择 -->
    <div class="font-color-row">
      <el-select v-model="formData.fontSize" size="small" style="width: 120px">
        <el-option
          v-for="item in fontSizeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <div class="color-picker-row">
        <div
          v-for="color in presetColors"
          :key="color.value"
          class="color-item"
          :class="{ active: formData.fontColor === color.value }"
          :style="{
            backgroundColor: color.value,
            borderColor: color.value,
          }"
          @click="onColorSelect(color.value)"
        >
          <span v-if="formData.fontColor === color.value" class="check-icon"
            >✓</span
          >
        </div>
        <div
          class="color-item custom-color"
          :class="{ active: isCustomColor }"
          :style="
            isCustomColor
              ? {
                  backgroundColor: formData.fontColor,
                  borderColor: formData.fontColor,
                }
              : {}
          "
          @click="showCustomColorPicker"
        >
          <img
            v-if="!isCustomColor"
            :src="imageUrl2 + '/12jielong/bdJL/color-picker.png'"
          />
          <span v-else class="check-icon">✓</span>
        </div>
      </div>
    </div>

    <!-- 自定义颜色选择器 -->
    <color-picker
      :visible.sync="showColorPickerPopup"
      :value="formData.fontColor"
      @confirm="onCustomColorConfirm"
      @cancel="onCustomColorCancel"
    />

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="warning" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PRESET_COLORS, FONT_SIZE_OPTIONS } from "../../constant";
import ColorPicker from "../ColorPicker/ColorPicker.vue";

export default {
  name: "TextEditPopup",

  components: {
    ColorPicker,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    region: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      formData: {
        content: "",
        fontSize: 24,
        fontColor: "#333333",
      },
      presetColors: PRESET_COLORS,
      fontSizeOptions: FONT_SIZE_OPTIONS,
      showColorPickerPopup: false,
      imageUrl2: "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/",
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    isCustomColor() {
      const color = this.formData.fontColor.toUpperCase();
      return !this.presetColors.some((c) => c.value.toUpperCase() === color);
    },
  },

  watch: {
    region: {
      handler(val) {
        if (val && val.config) {
          this.formData = {
            content: val.config.content || "",
            fontSize: val.config.fontSize || 24,
            fontColor: val.config.fontColor || "#333333",
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    onColorSelect(color) {
      this.formData.fontColor = color;
    },

    showCustomColorPicker() {
      this.showColorPickerPopup = true;
    },

    onCustomColorConfirm(color) {
      this.formData.fontColor = color;
      this.showColorPickerPopup = false;
    },

    onCustomColorCancel() {
      this.showColorPickerPopup = false;
    },

    handleConfirm() {
      if (!this.formData.content.trim()) {
        this.$message.warning("请输入文本内容");
        return;
      }

      const updatedRegion = {
        ...this.region,
        config: {
          ...this.region.config,
          content: this.formData.content,
          fontSize: this.formData.fontSize,
          fontColor: this.formData.fontColor,
        },
      };

      this.$emit("confirm", updatedRegion);
    },

    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  margin-bottom: 20px;

  .el-input {
    font-size: 14px;
  }
}

.font-color-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.color-picker-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-item {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  box-sizing: border-box;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }

  .check-icon {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  &.custom-color {
    overflow: hidden;
    background: conic-gradient(
      from 180deg,
      #ff6b6b 0deg,
      #ffe66d 60deg,
      #4ecb71 120deg,
      #4a9fe8 180deg,
      #9b6bff 240deg,
      #ff6b9d 300deg,
      #ff6b6b 360deg
    );

    img {
      width: 18px;
      height: 18px;
      border-radius: 4px;
    }
  }
}

.dialog-footer {
  text-align: right;

  .el-button--warning {
    background-color: #ff9900;
    border-color: #ff9900;

    &:hover {
      background-color: #ffad33;
      border-color: #ffad33;
    }
  }
}
</style>

<style lang="scss">
.text-edit-dialog {
  .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #e8e8e8;
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 12px 20px;
    border-top: 1px solid #e8e8e8;
  }
}
</style>
